
// This file is auto-generated. Do not edit manually.
export const config = {
  app: {
    name: "dealer-portal",
    version: "3.0.0",
    fullName: "dealer-portal-v3.0.0",
    versionCheckFrequency: 3600000
  },
  environment: {
    name: "production"
  },
  firebase: {
    claims: {
      namespace: "https://hasura.io/jwt/claims",
      allowedRegions: "x-hasura-allowed-regions",
      allowedRoles: "x-hasura-allowed-roles",
      defaultRole: "x-hasura-default-role",
      allowedCustomers: "x-hasura-allowed-customers",
      allowedPayers: "x-hasura-allowed-payers",
      payerChildCustomers: "x-hasura-payer-child-customers",
      customerId: "x-hasura-customer-id",
      userId: "x-hasura-user-id",
      driverId: "x-hasura-driver-id",
      userEmail: "x-hasura-user-email"
    }
  },
  graphql: {
    baseUrl: "gql.hopdrive.io",
    httpUrl: "https://gql.hopdrive.io/v1/graphql",
    wsUrl: "wss://gql.hopdrive.io/v1/graphql"
  },
  google: {
    clientUrl: "https://clients3.google.com/generate_204"
  },
  email: {
    info: "info@hopdrive.com",
    support: "support@hopdrive.com"
  },
  sentry: {
    url: "https://5186cd19f98e4077a5c9ed9ebea39b8c@o491290.ingest.sentry.io/6751078"
  },
  logging: {
    enableColoring: false,
    enabled: false
  },
  hopdrive: {
    admin: {
      url: "https://admin.hopdrive.io/"
    }
  }
} as any;
